import React from "react";
import { Selector, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const Logout = ({ confirmationOptions, onItemSelected }) => {
  return (
    <>
      <Text text={i18n.get("pages.settings.logout.areYouSure")} />
      <Selector items={confirmationOptions} onItemSelected={onItemSelected} selectedIndex={0} />
    </>
  );
};
